import { useStore } from "../store";
import {
  coachSelector,
  initWithUserSelector,
  initialisedSelector,
  dismissedTrustpilotReviewUserIdsSelector,
  dismissTrustpilotReviewSelector,
  needsRefreshAfterRehydrateSelector,
  activeOrgIdSelector,
  isSwitchingOrgSelector,
  setActiveOrgIdSelector,
  setSwitchingOrgSelector,
  orgSelector,
  orgsSelector,
  resetSelector,
  permissionsSelector,
  subscriptionSelector,
  userIdSelector,
  roleKeySelector,
  memberTypeSelector,
  hasTeamMembersSelector,
} from "./selectors";
import { Coach, Org, PermissionsMap, SessionOrgOption } from "./store";
import { hasAnyPermission, hasPermission } from "@/lib/permissions/permissions";

export function useCoach(): Coach | undefined {
  return useStore(coachSelector);
}

export function useOrg(): Org | undefined {
  return useStore(orgSelector);
}

export function useOrgs(): SessionOrgOption[] {
  return useStore(orgsSelector) ?? [];
}

export function useActiveOrgId(): string | null | undefined {
  return useStore(activeOrgIdSelector);
}

export function useIsSwitchingOrg(): boolean {
  return useStore(isSwitchingOrgSelector);
}

export function usePermissions(): PermissionsMap | undefined {
  return useStore(permissionsSelector);
}

export function useSubscription() {
  return useStore(subscriptionSelector);
}

export function useHasTeamMembers(): boolean {
  return useStore(hasTeamMembersSelector) ?? false;
}

export function useUserId(): string | null | undefined {
  return useStore(userIdSelector);
}

export function useRoleKey(): string | null | undefined {
  return useStore(roleKeySelector);
}

export function useMemberType(): string | null | undefined {
  return useStore(memberTypeSelector);
}

export function useHasPermission(permissionKey: string): boolean {
  const permissions = usePermissions();
  return hasPermission(permissionKey, permissions);
}

export function useHasAnyPermission(permissionKeys: string[]): boolean {
  const permissions = usePermissions();
  return hasAnyPermission(permissionKeys, permissions);
}

export function useSetActiveOrgId() {
  return useStore(setActiveOrgIdSelector);
}

export function useSetSwitchingOrg() {
  return useStore(setSwitchingOrgSelector);
}

export function useReset() {
  return useStore(resetSelector);
}

export function useSessionInitialised() {
  return useStore(initialisedSelector);
}

export function useTrustpilotReviewDismissed(userId: string | null | undefined) {
  const dismissedUserIds = useStore(dismissedTrustpilotReviewUserIdsSelector);
  const dismissTrustpilotReview = useStore(dismissTrustpilotReviewSelector);
  return {
    dismissed: !!userId && dismissedUserIds.includes(userId),
    dismiss: () => {
      if (userId) dismissTrustpilotReview(userId);
    },
  };
}

export function useNeedsRefreshAfterRehydrate() {
  return useStore(needsRefreshAfterRehydrateSelector);
}

export function useSessionInit() {
  return useStore(initWithUserSelector);
}
